import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Logo from "../../images/whiteLogo.svg";

import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { Container, Nav, Navbar, NavDropdown, Row } from "react-bootstrap";
import useAuthService from "../../session/useAuthService";
import { Icon } from "@iconify/react/dist/iconify.js";

import { Avatar, List, message, Popover } from "antd";
import { resetState } from "../../RTK/middleware";
import { useDispatch } from "react-redux";

function AdminHeader() {
  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const getActiveClass = (path) => (location.pathname === path ? "active" : "");

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  const handleLogout = () => {
    messageApi.open({
      type: "success",
      content: "Log Out Successfully",
      duration: 1,
      className: "ant-alert",
      onClose: () => {
        useAuthService.removeAuth();
        dispatch(resetState());
        navigate("/login");
      },
    });
  };

  const content = (
    <List
      className="cursor-pointer"
      bordered
      dataSource={[
        {
          text: "Log out",
          icon: <Icon icon="solar:logout-outline" width="24" height="24" />,
          action: handleLogout,
        },
      ]}
      renderItem={(item) => (
        <List.Item className="custom-popper-item" onClick={item.action}>
          {item.icon} <span>{item.text}</span>
        </List.Item>
      )}
    />
  );

  return (
    <>
    {contextHolder}
      <Navbar
        collapseOnSelect
        expand="lg"
        bg="dark"
      >
        <Container>
          <Navbar.Brand>
            <img src={Logo} alt="" className="uniteColorWhite" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link
                as={Link}
                to="/admin/clinicsList"
                className={`textWhite ${getActiveClass("/admin/clinicsList")}`} 
              >
                Provider List
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/admin/newRequest"
                className={`textWhite ${getActiveClass("/admin/newRequest")}`} 
              >
                New Request
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/admin/providers"
                className={`textWhite ${getActiveClass("/admin/providers")}`} 

              >
                Providers
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/admin/blockedProviders"
                className={`textWhite ${getActiveClass("/admin/blockedProviders")}`} 
              >
                Blocked Providers
              </Nav.Link>
              {/* <Nav.Link
                as={Link}
                to="/admin/addProvider"
                className={`textWhite ${getActiveClass("/admin/addProvider")}`} 
              >
                Add Provider
              </Nav.Link> */}
            </Nav>
            <Nav className="justify-content-end">
            <Popover
              className={`cursor-pointer adminProfile-popper ${
                open ? "profile-popper-active" : ""
              }`}
              content={content}
              title="Profile"
              placement="bottomRight"
              trigger="click"
              open={open}
              onOpenChange={handleOpenChange}
            >
              <Avatar
                size="small"
                // style={{ backgroundColor: "white", verticalAlign: "middle" }}
                icon={
                  <Icon
                    icon="basil:user-solid"
                    width="24"
                    height="24"
                    // style={{ color: "#0D224E" }}
                  />
                }
              />
              &ensp; {useAuthService.getName() ?? "Admin"}
            </Popover>
            {/* <NavDropdown
              title={useAuthService.getName()}
              id="hospital-nav-dropdown"
            >
              <NavDropdown.Item onClick={() => handleLogout()}>
                LogOut{" "}
                <Icon icon="solar:logout-outline" width="24" height="24" />
              </NavDropdown.Item>
            
            </NavDropdown> */}
          </Nav>
          </Navbar.Collapse>
          
        </Container>
      </Navbar>
      <Row className="m-0">
        <Outlet />
      </Row>
    </>
  );
}

export default AdminHeader;
